module.exports = __webpack_public_path__ + "img/slogan.1ab23877.png";